export const generos = [
    { key: "Hombre", text: "Hombre", value: "Hombre" },
    { key: "Mujer", text: "Mujer", value: "Mujer" },
    { key: "Ambos", text: "Ambos", value: "Ambos" }
];


export const familia = [
    { key: "Oxidermic", text: "Oxidermic", value: "Oxidermic" },
    { key: "Sunveil", text: "Sunveil", value: "Sunveil" },
    { key: "Dibel", text: "Dibel", value: "Dibel" },
    { key: "Neudermic", text: "Neudermic", value: "Neudermic" },
    { key: "ClareSkin", text: "ClareSkin", value: "ClareSkin" },
    { key: "Capilarium", text: "Capilarium", value: "Capilarium" },
    { key: "No aplica", text: "No aplica", value: "No aplica" },
];

export const piel = [
    { key: "Normal", text: "Normal", value: "Normal" },
    { key: "Seca", text: "Seca", value: "Seca" },
    { key: "Mixta", text: "Mixta", value: "Mixta" },
    { key: "Grasa", text: "Grasa", value: "Grasa" },
    { key: "Otros", text: "Otros", value: "Otros" },
    { key: "NA", text: "No aplica", value: "NA" }
];

export const opcionesBaseAreas = [
    { key: "Contorno de ojos", text: "Contorno de ojos", value: "Contorno de ojos" },
    { key: "Cara", text: "Cara", value: "Cara" },
    { key: "Manos", text: "Manos", value: "Manos" },
    { key: "Corporal", text: "Corporal", value: "Corporal" }
];

export const opcionesBaseBase = [
    { key: "Crema", text: "Crema", value: "Crema" },
    { key: "Gel", text: "Gel", value: "Gel" },
    { key: "Gel-Crema", text: "Gel-Crema", value: "Gel-Crema" },
    { key: "Suero", text: "Suero", value: "Suero" },
    { key: "Loción", text: "Loción", value: "Loción" },
    { key: "Jabón", text: "Jabón", value: "Jabón" },
    { key: "Shampoo", text: "Shampoo", value: "Shampoo" }
];

export const opcionesBaseEnvase = [
    { key: "Frasco cilíndrico", text: "Frasco cilíndrico", value: "Frasco cilíndrico" },
    { key: "Pomadera", text: "Pomadera", value: "Pomadera" },
    { key: "Airless", text: "Airless", value: "Airless" }
];
